var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": "0.98rem", background: "#fff" } },
    [
      _c("topbar", { attrs: { text: "电子书" } }),
      _vm._v(" "),
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "topBox" }, [
          _c("img", {
            staticClass: "itemIcon",
            attrs: { src: _vm.EnvUrl + _vm.detail.bookPic, alt: "" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "itemRight" }, [
            _c("div", [
              _c("div", { staticClass: "itemTitle" }, [
                _vm._v(_vm._s(_vm.detail.title))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "itemTagline" }, [
                _vm._v(_vm._s(_vm.detail.tagline))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "itemBottomBox" }, [
              _c("div", { staticClass: "num" }, [
                _vm._v("共" + _vm._s(_vm.detail.catalogCount) + "章")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "num" }, [
                _vm._v(_vm._s(_vm.detail.readCount) + "人学习")
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [_vm._v("简介")]),
        _vm._v(" "),
        _c("div", {
          staticClass: "content",
          domProps: { innerHTML: _vm._s(_vm.detail.content) }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [_vm._v("目录")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "catalogueList" },
          _vm._l(_vm.list, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "catalogueItem",
                on: {
                  click: function($event) {
                    _vm.change(item.catalogId)
                  }
                }
              },
              [
                _vm._v(
                  "\n            " + _vm._s(item.catalogName) + "\n            "
                ),
                !(_vm.detail.payType == 0 || _vm.orderNo)
                  ? _c("img", {
                      staticClass: "lock",
                      attrs: { src: require("assets/cr_lock.png"), alt: "" }
                    })
                  : _vm._e()
              ]
            )
          })
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btnBox" }, [
        !(_vm.detail.payType == 0 || _vm.orderNo)
          ? _c("div", { staticClass: "btn", on: { click: _vm.showMask } }, [
              _vm._v("购买书单 ￥" + _vm._s(_vm.detail.bookPrice))
            ])
          : _c("div", { staticClass: "btn", on: { click: _vm.to } }, [
              _vm._v("立即阅读")
            ])
      ]),
      _vm._v(" "),
      _vm.mask
        ? _c("pay", {
            attrs: {
              price: _vm.detail.bookPrice,
              microId: "",
              bookId: _vm.detail.bookId
            },
            on: { close: _vm.closeMask }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11e60d7f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11e60d7f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/eBookDetail.vue
// module id = null
// module chunks = 